import React, { useState, useEffect, useRef } from "react";
import { jwtDecode } from "jwt-decode";
import {
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  Card,
  Button,
  Offcanvas,
  Carousel,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./Header.css";
import logoimage from "../assets/images/aiota.png";
import { restrictionConfig } from "../constants/restrictionConfig";
import RestrictionModal from "../components/RestrictionModal";
import { getAdSubmissions } from "../utils/adAPI";
import adImage1 from "../assets/images/adImage1.jpg";

const Header = () => {
  const navigate = useNavigate();
  const [activeMenu, setActiveMenu] = useState(null);
  const [clickedMenu, setClickedMenu] = useState(null);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const timeoutRef = useRef(null);
  const [isNearFooter, setIsNearFooter] = useState(false);
  const [tokenState, setTokenState] = useState(localStorage.getItem("token"));
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const [adImages, setAdImages] = useState([adImage1]);
  const [showRestrictionModal, setShowRestrictionModal] = useState(false);
  const [restrictedUserName, setRestrictedUserName] = useState("User");

  useEffect(() => {
    const userData = localStorage.getItem("user");
    if (userData) {
      try {
        const user = JSON.parse(userData);
        setRestrictedUserName(user.name || "User");
      } catch (e) {
        setRestrictedUserName("User");
      }
    }
  }, []);

  useEffect(() => {
    const fetchAds = async () => {
      try {
        const ads = await getAdSubmissions(1, true);
        if (ads && ads.length > 0) {
          const imageUrls = ads
            .map((ad) => ad?.advertisement_image)
            .filter(Boolean);
          if (imageUrls.length > 0) {
            setAdImages(imageUrls);
          }
        }
      } catch (error) {
        console.error("Failed to fetch ads:", error);
      }
    };

    fetchAds();
  }, []);

  const token = localStorage.getItem("token");
  if (token && typeof token === "string" && token.split(".").length === 3) {
    try {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;

      if (currentTime >= decodedToken.exp) {
        console.log("Token has expired");
        localStorage.removeItem("user");
        localStorage.removeItem("token");
      }
    } catch (e) {
      console.error("Invalid token:", e);
    }
  }
  const isMultiple = adImages.length > 1;

  const navItems = [
    {
      label: "Home",
      path: "/",
    },
    {
      label: "AIOTA",
      path: "#",
      subItems: [
        {
          href: "/about-aiota",
          title: "About AIOTA",
          desc: "Learn more about the All India Occupational Therapists' Association.",
        },
        {
          href: "/executives",
          title: "Executives",
          desc: "Meet the executive members leading AIOTA.",
        },
        {
          href: "/about-logo",
          title: "About Logo",
          desc: "Discover the meaning and symbolism of AIOTA’s logo.",
        },
        {
          href: "/elections",
          title: "Elections",
          desc: "Find details about upcoming and past AIOTA elections.",
        },
        {
          href: "/awards",
          title: "Awards",
          desc: "Explore the various awards and recognitions given by AIOTA.",
        },
        {
          href: "/license-professional-status",
          title: "License Verification/Professional status",
          desc: "Verify membership or professional license details.",
        },
        {
          href: "/vision",
          title: "Vision/Mission",
          desc: "Explore AIOTA’s mission and vision for occupational therapy.",
        },
        {
          href: "/photo-gallery",
          title: "Photo Gallery",
          desc: "Browse photos from AIOTA events and activities.",
        },
        {
          href: "/branches",
          title: "Branches",
          desc: "Browse AIOTA branches and their regional activities.",
        },
        {
          href: "/webinar",
          title: "Webinars",
          desc: "Join and learn from AIOTA’s webinars and online sessions.",
        },
        {
          href: "/president-secretaries",
          title: "President and Secretaries",
          desc: "Chronological record of AIOTA Presidents and Secretaries, highlighting their tenure periods.",
        },
        {
          href: "https://aiota-live.s3.ap-south-1.amazonaws.com/uploads/THE+CONSTITUTION.pdf",
          title: "AIOTA Bye Laws and Constitution",
          desc: "Official document outlining the rules, regulations, and governance framework of AIOTA.",
        },
      ],
    },
    {
      label: "ACOT",
      path: "/acot",
      subItems: [
        {
          href: "/acot-executives",
          title: "ACOT Executives",
          desc: "Meet the executive team of the Academic Council of Occupational Therapy (ACOT).",
        },
        {
          href: "/accredited-colleges",
          title: "Accredited Colleges",
          desc: "Explore the list of AIOTA-accredited occupational therapy colleges across India.",
        },
        {
          href: "/FACOT",
          title: "FACOT",
          desc: "Learn about the Fellowship of the Academic Council of Occupational Therapy (FACOT).",
        },
        {
          href: "/resources",
          title: "Resources",
          desc: "Access academic, professional, and research resources for occupational therapists.",
        },
        // {
        //   href: "/professional-advancement",
        //   title: "Professional Advancement",
        //   desc: "Stay updated on career growth, training, and advancement opportunities in OT.",
        // },
        // {
        //   href: "https://aiotadev.s3.ap-south-1.amazonaws.com/uploads/Guidelines%20%20IOTR%20April%202020.pdf",
        //   title: "IOTR",
        //   desc: "Allows to ethically and legally practice Occupational Therapy in India.",
        // },
        // {
        //   href: "/opportunities",
        //   title: "Opportunities",
        //   desc: "Explore the latest career openings, training programs, research fellowships, and professional growth opportunities in Occupational Therapy.",
        // },
      ],
    },
    {
      label: "Memberships",
      path: "/memberships",
      subItems: [
        {
          href: "/member-login",
          title: "Associate Member Login",
          desc: "Login portal for Associate Members to access their membership dashboard, benefits, and resources.",
        },
        {
          href: "/member-login",
          title: "Life Member Login",
          desc: "Login portal for Life Members to manage their membership, view exclusive content, and stay updated.",
        },
        {
          href: "https://aiotadev.s3.ap-south-1.amazonaws.com/uploads/1774420282343-Student_Membership_new.pdf",
          title: "Apply Student Membership",
          desc: "Download the application form to apply for Student Membership and begin your journey with AIOTA.",
        },
      ],
    },
    {
      label: "Ergonomic Certification",
      path: "/edcc",
      subItems: [
        {
          href: "/EDCC-Members",
          title: "EDCC Members",
          desc: "View the members of the Executive Development and Coordination Committee (EDCC).",
        },
        {
          href: "/Company-List",
          title: "List of companies/industries registered with AIOTA",
          desc: "Browse companies and industries officially registered with AIOTA.",
        },
        {
          href: "https://aiotadev.s3.ap-south-1.amazonaws.com/uploads/1776842633466-AIOTA%20Regulation%20for%20CERTIFICATION%20%28Guidelines%29%202024-2028.pdf",
          title: "AIOTA Regulations for Certification",
          desc: "Learn about AIOTA’s rules and regulations for certification and practice.",
        },
      ],
    },
    {
      label: "IJOT",
      path: "/ijot",
      subItems: [
        {
          href: "/IJOT",
          title: "IJOT",
          desc: "Access the Indian Journal of Occupational Therapy (IJOT) and explore research articles.",
        },
        {
          href: "https://journals.lww.com/iopt/pages/default.aspx",
          title: "Author's Guidelines",
          desc: "Read detailed instructions and guidelines for authors submitting to IJOT.",
        },
        {
          href: "https://review.jow.medknow.com/ijoth",
          title: "Manuscript-Submission",
          desc: "Submit your manuscripts online for publication consideration in IJOT.",
        },
        {
          href: "/IJOT-Issues",
          title: "IJOT Issues",
          desc: "Browse past and current issues of the Indian Journal of Occupational Therapy (IJOT).",
        },
        {
          href: "/IJOT-Promotions",
          title: "IJOT-Promotions",
          desc: "Explore promotions, highlights, and outreach initiatives of IJOT.",
        },
        {
          href: "/News-Letter",
          title: "NewsLetter",
          desc: "Stay updated with AIOTA’s official newsletters and announcements.",
        },
      ],
    },
    {
      label: "WFOT",
      path: "/wfot",
    },
    {
      label: "Contact",
      path: "/contact",
      subItems: [
        {
          href: "/Contact-Us",
          title: "Contact-Us",
          desc: "Get in touch with AIOTA for inquiries, support, or feedback.",
        },
        {
          href: "/faq",
          title: "Frequently Asked Questions",
          desc: "Find answers to common questions about AIOTA and its services.",
        },
        {
          href: "/Download",
          title: "Download",
          desc: "Access downloadable forms, documents, and resources from AIOTA.",
        },
      ],
    },
  ];

  const handleClick = () => {
    navigate("/ad-submission");
  };

  // Helper function to check if a link is external
  const isExternalLink = (href) => {
    return href.startsWith("http://") || href.startsWith("https://");
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const currentToken = localStorage.getItem("token");
      if (currentToken !== tokenState) {
        setTokenState(currentToken);
      }
    }, 500);

    return () => clearInterval(interval);
  }, [tokenState]);

  const profileMenuItem = tokenState
    ? {
        label: "profile",
        path: "/profile",
      }
    : null;

  const restrictedRoutes = [
    "/terms-conditions",
    "/stepper-form",
    "/old-member-terms-conditions",
    "/old-member-form",
    "/membership-renewal-upload",
    "/membership-renewal-terms",
    "/membership-renewal-payment",
    "/license-verification",
    "/license-verification-form",
    "/license-verification-payment",
    "/professional-status",
    "/professional-status-form",
    "/professional-status-payment",
    "/license-professional-status",
  ];

  const handleMenuClick = (label, path, hasSubItems) => {
    if (hasSubItems) {
      setClickedMenu((prev) => (prev === label ? null : label));
      setActiveMenu((prev) => (prev === label ? null : label));
    } else {
      if (
        restrictionConfig.isApplicationPaused &&
        restrictedRoutes.includes(path)
      ) {
        setShowRestrictionModal(true);
        return;
      }
      setClickedMenu(null);
      setActiveMenu(null);
      setShowOffcanvas(false);
      navigate(path);
    }
  };

  const handleMouseEnter = (label, hasSubItems) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    if (hasSubItems && !isMobile) {
      setActiveMenu(label);
    }
  };

  const handleMouseLeave = (label, hasSubItems) => {
    if (hasSubItems && !clickedMenu && !isMobile) {
      timeoutRef.current = setTimeout(() => {
        setActiveMenu(null);
      }, 300);
    }
  };

  const handleClickOutside = (event) => {
    if (
      !event.target.closest(".nav-item") &&
      !event.target.closest(".mega-menu") &&
      !event.target.closest(".profile-menu") &&
      !event.target.closest(".offcanvas")
    ) {
      setClickedMenu(null);
      setActiveMenu(null);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991);
      if (window.innerWidth > 991) {
        setShowOffcanvas(false); // Close Offcanvas on resize to desktop
      }
    };
    const handleScroll = () => {
      const footer = document.querySelector(".footer");
      if (footer) {
        const footerTop = footer.getBoundingClientRect().top + window.scrollY;
        const scrollPosition = window.scrollY + window.innerHeight;
        if (scrollPosition >= footerTop - 100 && window.scrollY > 50) {
          setIsNearFooter(true);
        } else {
          setIsNearFooter(false);
        }
      }
    };

    window.addEventListener("resize", handleResize);
    document.addEventListener("scroll", handleScroll);
    document.addEventListener("click", handleClickOutside);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
      document.removeEventListener("scroll", handleScroll);
      document.removeEventListener("click", handleClickOutside);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <header>
      <Navbar
        bg="light"
        expand="lg"
        className={`shadow-sm custom-navbar ${
          isNearFooter ? "navbar-near-footer" : ""
        }`}
        fixed="top"
      >
        <Container fluid>
          {isMobile && (
            <>
              {/* Toggle Button - left */}
              <Navbar.Toggle
                aria-controls="offcanvasNavbar"
                onClick={() => setShowOffcanvas(true)}
              />

              {/* Logo - center */}
              <Navbar.Brand href="/" className="">
                <img
                  src={logoimage}
                  className="d-inline-block align-top logo"
                  alt="AIOTA Logo"
                />
              </Navbar.Brand>
              <Navbar.Offcanvas
                id="offcanvasNavbar"
                aria-labelledby="offcanvasNavbarLabel"
                placement="start"
                show={showOffcanvas}
                onHide={() => setShowOffcanvas(false)}
              >
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title id="offcanvasNavbarLabel">
                    <img
                      src={logoimage}
                      className="d-inline-block align-top logo"
                      alt="AIOTA Logo"
                    />
                  </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <Nav className="flex-column">
                    {navItems.map((item, idx) => (
                      <Nav.Item key={idx} className="w-100">
                        <div
                          className={`nav-link fw-medium d-flex justify-content-between align-items-center ${
                            activeMenu === item.label ? "active" : ""
                          }`}
                          onClick={() =>
                            handleMenuClick(
                              item.label,
                              item.path,
                              !!item.subItems,
                            )
                          }
                          style={{ cursor: "pointer", padding: "10px 15px" }}
                        >
                          <span>{item.label}</span>
                          {item.subItems && (
                            <span
                              className={`chevron ${
                                activeMenu === item.label ? "rotate" : ""
                              }`}
                            >
                              ▾
                            </span>
                          )}
                        </div>
                        {item.subItems && activeMenu === item.label && (
                          <div className="sub-menu">
                            {item.subItems.map((sub, subIdx) => (
                              <Nav.Link
                                key={subIdx}
                                href={sub.href}
                                className="sub-menu-item"
                                {...(isExternalLink(sub.href)
                                  ? {
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                    }
                                  : {})}
                                onClick={() => {
                                  if (!isExternalLink(sub.href)) {
                                    setShowOffcanvas(false);
                                    setClickedMenu(null);
                                    setActiveMenu(null);
                                    navigate(sub.href);
                                  }
                                }}
                                style={{
                                  padding: "8px 30px",
                                  fontSize: "0.9rem",
                                  color: "#333",
                                }}
                              >
                                {sub.title}
                              </Nav.Link>
                            ))}
                          </div>
                        )}
                      </Nav.Item>
                    ))}
                  </Nav>
                </Offcanvas.Body>
              </Navbar.Offcanvas>
            </>
          )}

          {!isMobile && (
            <Navbar.Collapse id="basic-navbar-nav">
              <Navbar.Brand href="/" className="">
                <img
                  src={logoimage}
                  className="d-inline-block align-top logo"
                  alt="AIOTA Logo"
                />
              </Navbar.Brand>
              <Nav className="w-100 justify-content-center d-flex align-items-center gap-2">
                {navItems.map((item, idx) => (
                  <div
                    key={idx}
                    className="nav-item position-relative text-center"
                    onMouseEnter={() =>
                      handleMouseEnter(item.label, !!item.subItems)
                    }
                    onMouseLeave={() =>
                      handleMouseLeave(item.label, !!item.subItems)
                    }
                  >
                    <Nav.Link
                      href={item.subItems ? undefined : item.path}
                      className="fw-medium aiota-nav d-flex align-items-center"
                      onClick={() =>
                        handleMenuClick(item.label, item.path, !!item.subItems)
                      }
                      style={{ cursor: "pointer" }}
                    >
                      {item.label}
                    </Nav.Link>
                    {(activeMenu === item.label ||
                      clickedMenu === item.label) &&
                      item.subItems && (
                        <div
                          className="mega-menu"
                          onMouseEnter={() =>
                            handleMouseEnter(item.label, true)
                          }
                          onMouseLeave={() =>
                            handleMouseLeave(item.label, true)
                          }
                        >
                          <Container fluid className="sub-menu-container">
                            <Row className="d-flex flex-lg-row justify-content-between">
                              <Col md={9} className="sub-menu-category-section">
                                <Row className="row-gap-2">
                                  {item.subItems
                                    .slice(0, 13)
                                    .map((sub, index) => (
                                      <Col
                                        md={4}
                                        key={index}
                                        className="sub-menu-item-container"
                                      >
                                        <Card
                                          className="border-0 category-item category-card"
                                          style={{ cursor: "pointer" }}
                                        >
                                          <Card.Body className="p-0">
                                            <a
                                              href={sub.href}
                                              className="text-decoration-none d-flex align-items-start"
                                              {...(isExternalLink(sub.href)
                                                ? {
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                  }
                                                : {})}
                                              onClick={(e) => {
                                                if (!isExternalLink(sub.href)) {
                                                  e.stopPropagation();
                                                  if (
                                                    restrictionConfig.isApplicationPaused &&
                                                    restrictedRoutes.includes(
                                                      sub.href,
                                                    )
                                                  ) {
                                                    setShowRestrictionModal(
                                                      true,
                                                    );
                                                    return;
                                                  }
                                                  setClickedMenu(null);
                                                  setActiveMenu(null);
                                                  navigate(sub.href);
                                                }
                                              }}
                                            >
                                              <div className="category-icon d-flex align-items-start mt-1 me-1 justify-content-center">
                                                {/* <i
                                                className={`fas fa-${
                                                  index === 0
                                                    ? "chart-line"
                                                    : index === 1
                                                    ? "mobile-alt"
                                                    : index === 2
                                                    ? "paint-brush"
                                                    : "code"
                                                } `}
                                              ></i> */}
                                              </div>
                                              <div>
                                                <Card.Title className="h5 mb-1 text-dark text-start">
                                                  {sub.title}
                                                </Card.Title>
                                                <Card.Text className="small text-muted mb-0 text-start">
                                                  {sub.desc}
                                                </Card.Text>
                                              </div>
                                            </a>
                                          </Card.Body>
                                        </Card>
                                      </Col>
                                    ))}
                                </Row>
                              </Col>
                              <Col md={3} className="promo-section">
                                <Card className="bg-light border-0 promo-card h-100">
                                  <Card.Body className="d-flex flex-column align-items-center justify-content-between p-2">
                                    {/* Image / Slider */}
                                    <div className="text-center promo-section-image w-100 flex-grow-1">
                                      {isMultiple ? (
                                        <Carousel
                                          interval={3000}
                                          indicators={false}
                                          controls={false}
                                        >
                                          {adImages.map((img, index) => (
                                            <Carousel.Item key={index}>
                                              <img
                                                src={img}
                                                alt={`Ad ${index + 1}`}
                                                className="img-fluid rounded w-100"
                                                style={{
                                                  objectFit: "cover",
                                                  height: "100%",
                                                  maxHeight: "160px",
                                                }}
                                              />
                                            </Carousel.Item>
                                          ))}
                                        </Carousel>
                                      ) : (
                                        <img
                                          src={adImages[0]}
                                          alt="Advertisement"
                                          className="img-fluid rounded w-100"
                                          style={{
                                            objectFit: "cover",
                                            height: "100%",
                                            maxHeight: "160px",
                                          }}
                                        />
                                      )}
                                    </div>

                                    {/* Button */}
                                    <Button
                                      variant="primary"
                                      size="sm"
                                      className="mt-2 px-3 py-1 fw-normal w-auto"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setClickedMenu(null);
                                        setActiveMenu(null);
                                        handleClick();
                                      }}
                                    >
                                      Advertise Here!
                                    </Button>
                                  </Card.Body>
                                </Card>
                              </Col>
                            </Row>
                          </Container>
                        </div>
                      )}
                  </div>
                ))}
              </Nav>
            </Navbar.Collapse>
          )}

          {profileMenuItem && (
            <Nav className="ms-auto profile-nav">
              <div className="nav-item position-relative profile-dropdown">
                <Nav.Link
                  className="d-flex align-items-center profile-link"
                  onClick={() => {
                    const userStr = localStorage.getItem("user");
                    let rolename = "";
                    if (userStr) {
                      try {
                        const userObj = JSON.parse(userStr);
                        rolename = userObj.rolename;
                      } catch (e) {
                        rolename = "";
                      }
                    }
                    if (
                      rolename === "AssociateMember" ||
                      rolename === "LifeMember"
                    ) {
                      navigate("/aiota-member-profile");
                    } else if (rolename === "EDCC") {
                      navigate("/edccprofile");
                    }
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <i className="far fa-circle-user profile-icon"></i>
                </Nav.Link>
              </div>
            </Nav>
          )}
        </Container>
      </Navbar>
      <RestrictionModal
        show={showRestrictionModal}
        onHide={() => setShowRestrictionModal(false)}
        title={restrictionConfig.popupTitle}
        message={restrictionConfig.popupMessage}
        buttonText={restrictionConfig.buttonText}
        userName={restrictedUserName}
      />
    </header>
  );
};

export default Header;
